export enum UniqueByField {
  ParentSku = 'parent_sku',
  Sku = 'sku',
}
